export default __webpack_public_path__ + "static/media/Inter-SemiBold.2244d96c.woff2";